import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
	return <div className={cn("card", className)} {...props} />;
}

interface CardHeadProps {
	title: ReactNode;
	sub?: ReactNode;
	right?: ReactNode;
	className?: string;
}

export function CardHead({ title, sub, right, className }: CardHeadProps) {
	return (
		<div className={cn("card-h", className)}>
			<div>
				<h3>{title}</h3>
				{sub && <p className="sub muted">{sub}</p>}
			</div>
			{right}
		</div>
	);
}

export function CardBody({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={cn("card-b", className)} {...props} />;
}
